import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-accounts-list',
  templateUrl: './../../../templates/forms/modals/user-list.component.html',
})
export class UserListComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  optionalParam:any;

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "UserListGrid"
  userList: any[] = [];
  searchFields: any[] = ['EMP_NAME', 'USER_NO'];
  public searchString;

  constructor(public langService: LangService,
     private comService: CommonService,
      public gridService: GridService) {
        this.colObj = [
          { headerName: langService.langData.employeeNameId, field: 'EMP_NAME', sortable: true, resizable: true, hide: false }
        ];
       }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }

  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.comService.getUsersList().subscribe(arg => {
      this.userList = arg.body
    });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }

}